import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export function Breadcrumb({ items, className = '' }) {
  if (!items || items.length === 0) return null;

  return (
    <nav className={`min-w-0 ${className}`} aria-label="Breadcrumb">
      {/* Single line: intermediate crumbs stay intact, the last (often a long
          title) truncates so the breadcrumb never wraps and breaks the
          fixed-height header on mobile. */}
      <ol className="flex flex-nowrap items-center min-w-0">
        {items.map((item, currentIndex) => {
          const isLast = currentIndex === items.length - 1;
          const isFirst = currentIndex === 0;
          const uniqueKey = `${item.href}-${item.label}`;

          return (
            <li
              key={uniqueKey}
              className={`flex items-center py-1 ${
                isLast ? 'min-w-0' : 'flex-shrink-0'
              }`}
            >
              {!isFirst && (
                <ChevronRight className="w-3 h-3 text-[var(--text-faint)] flex-shrink-0 mx-1 md:mx-1.5" />
              )}
              {isLast ? (
                <span
                  className="text-xs font-medium text-[var(--text-faint)] truncate"
                  title={item.label}
                >
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className="text-xs font-medium text-[var(--text-muted)] hover:text-[var(--primary)] whitespace-nowrap"
                  title={item.label}
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
